export const FileCopyHelper = {
  bucketDestination:
    process.env.REACT_APP_ENV === 'production' ? 'logicomix-archive' : 'logicomix-archive-staging',
}
